import { DateTime } from "luxon";
import { getDateLikeIsoDate } from "util/dates";

/**
 * Task deadlines are date-only values stored at UTC midnight; they must be
 * read in UTC or viewers west of UTC see the previous calendar day (see
 * `getDaysOverdue` in statusStyles.tsx, which pins UTC the same way).
 */
export const normalizeDateValue = (value: string | Date | DateTime | null): DateTime | null => {
  if (value instanceof Date) {
    return DateTime.fromJSDate(value, { zone: "utc" });
  }
  if (value instanceof DateTime) {
    return value;
  }
  if (typeof value === "string") {
    return DateTime.fromISO(value, { zone: "utc" });
  }
  return null;
};

/**
 * Compares a task deadline to a document due date by calendar date: the
 * deadline is read in UTC (stored UTC midnight) and the doc date by its
 * literal date prefix (`getDateLikeIsoDate`, how the submission form reads
 * the same value), so an in-sync pair never looks out-of-sync to a viewer in
 * a non-UTC timezone.
 */
export function deadlineMatchesDueDateIso(
  deadline: Date | null,
  dueDateIso: string | null
): boolean {
  if (dueDateIso === null && deadline === null) {
    return true;
  }
  if (dueDateIso === null || deadline === null) {
    return false;
  }
  const fromTask = DateTime.fromJSDate(deadline, { zone: "utc" }).toISODate();
  const fromDoc = getDateLikeIsoDate(dueDateIso) ?? null;
  return fromTask === fromDoc;
}
